import { isValidSimulationPreset } from './SimulationPreset';
export const simulationPresetApiToSimulationPresetEntity = simulationPreset => {
  var _simulationPreset$rev, _simulationPreset$eve;
  if (!simulationPreset) {
    throw new Error('Invalid simulation preset', {
      cause: {
        simulationPreset
      }
    });
  }
  const convertedSimulationPreset = {
    id: simulationPreset.id ?? undefined,
    revision: ((_simulationPreset$rev = simulationPreset.revision) == null ? void 0 : _simulationPreset$rev.toString()) ?? undefined,
    createdDate: simulationPreset.createdDate,
    updatedDate: simulationPreset.updatedDate,
    name: simulationPreset.name ?? '',
    description: simulationPreset.description ?? '',
    initialNoteExamples: simulationPreset.initialNoteExamples ?? [],
    additionalNoteExamples: simulationPreset.additionalNoteExamples ?? [],
    simulationSize: simulationPreset.simulationSize ?? 1,
    eventTemplates: ((_simulationPreset$eve = simulationPreset.eventTemplates) == null ? void 0 : _simulationPreset$eve.map(relativeEventTemplateApiToEntity)) ?? [],
    supervisorCriteriaIds: simulationPreset.supervisorCriteriaIds ?? [],
    executorCriteriaIds: simulationPreset.executorCriteriaIds ?? []
  };
  if (isValidSimulationPreset(convertedSimulationPreset)) {
    return convertedSimulationPreset;
  }
  throw new Error('Invalid simulation preset data', {
    cause: {
      convertedSimulationPreset
    }
  });
};
const relativeEventTemplateApiToEntity = template => {
  if (!template) {
    return {
      dayOffset: 0,
      startTime: '09:00',
      endTime: '10:00',
      title: ''
    };
  }
  return {
    dayOffset: template.dayOffset ?? 0,
    startTime: template.startTime ?? '09:00',
    endTime: template.endTime ?? '10:00',
    title: template.title ?? '',
    description: template.description ?? undefined,
    location: template.location ?? undefined,
    participantEmails: template.participantEmails ?? undefined
  };
};
export const simulationPresetEntityToApi = preset => {
  return {
    id: preset.id,
    revision: preset.revision ?? undefined,
    name: preset.name,
    description: preset.description,
    initialNoteExamples: preset.initialNoteExamples,
    additionalNoteExamples: preset.additionalNoteExamples,
    simulationSize: preset.simulationSize,
    eventTemplates: preset.eventTemplates.map(relativeEventTemplateEntityToApi),
    supervisorCriteriaIds: preset.supervisorCriteriaIds,
    executorCriteriaIds: preset.executorCriteriaIds
  };
};
const relativeEventTemplateEntityToApi = template => {
  return {
    dayOffset: template.dayOffset,
    startTime: template.startTime,
    endTime: template.endTime,
    title: template.title,
    description: template.description,
    location: template.location,
    participantEmails: template.participantEmails
  };
};
//# sourceMappingURL=converters.js.map